// src/scoring.js

const fruitValues = {
  "🍎": 0.5,
  "🍌": 1.0,
  "🍒": 1.5,
  "🍇": 2.0,
  "🍉": 2.5,
  "🍓": 3.0,
  "🍍": 3.5,
  "🥝": 4.0,
  "🍑": 5.0,
  "💎": 10.0, // Maximum jackpot payout
};

const maxJackpot = 10.0;

const calculateWinnings = (reels) => {
  let winnings = 0;
  let win = false;
  for (let i = 0; i < 3; i++) {
    if (reels[0][i] === reels[1][i] && reels[1][i] === reels[2][i]) {
      winnings += fruitValues[reels[0][i]];
      win = true;
    }
  }

  // Ensure winnings do not exceed the maximum jackpot
  if (winnings > maxJackpot) {
    winnings = maxJackpot;
  }

  return { winnings, win };
};

const calculateWinProbability = (float) => {
  // Adjust probability based on the float
  return float > 50 ? 40 : 30; // Increase chance if float is high
};

const calculateJackpotProbability = (float) => {
  // Adjust probability based on the float
  return float > 50 ? 1 : 0.2; // Increase chance if float is high
};

export {
  calculateWinnings,
  calculateWinProbability,
  calculateJackpotProbability,
  fruitValues,
  maxJackpot,
};
